import { createSlice } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { AddressSuggestion, LoginResponse, OrderType } from "../../types";

interface SessionState {
  user?: LoginResponse;
  search: {
    address?: AddressSuggestion;
    orderType: OrderType;
  };
}

const initialState: SessionState = {
  search: {
    orderType: OrderType.DELIVERY,
  },
};

export const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    logout(state) {
      delete state.user;
    },
    setUser(state, action) {
      const user = action.payload;
      state.user = user;
    },
    setAddress(state, action) {
      state.search.address = action.payload;
    },
    setOrderType(state, action) {
      state.search.orderType = action.payload;
    },
  },
});

export const sessionReducer = persistReducer(
  {
    key: "rtk:session",
    storage,
    whitelist: ["user", "search"],
  },
  sessionSlice.reducer
);

export const { logout, setAddress, setUser, setOrderType } =
  sessionSlice.actions;
